<div class="container" fxLayout="column">
  <div fxLayout="row" fxFlex="100">
    <div fxFlex="100" fxLayoutAlign="center">
      <h2 mat-dialog-title class="title">{{selectedImage?.image_type}} Details</h2>
    </div>
    <div fxLayoutAlign="end center" fxLayoutGap="10px">
      <button mat-icon-button class="close-icon" (click)="navigateToUpload()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div mat-dialog-content class="image-details-container" fxLayout="row" fxLayoutGap="30" fxLayout.xs="column">
    <div class="image-wrapper" fxFlex="60" fxFlex.xs="100">
      <img [src]="selectedImage?.image_url" class="uploaded-image" fxFlex="100">
    </div>
    
    <div class="image-details-content" fxFlex="55" fxFlex.xs="100" fxLayout="column">
      <table>
        <tbody>
          <tr *ngIf="selectedImage?.title">
            <td class="detail-label">Title:</td>
            <td>{{selectedImage?.title}}</td>
          </tr>
          <tr *ngIf="selectedImage?.description">
            <td class="detail-label">Description:</td>
            <td>{{selectedImage?.description}}</td>
          </tr>
          <!-- <tr *ngIf="selectedImage?.image_type">
            <td class="detail-label">Image Type:</td>
            <td>{{selectedImage?.image_type}}</td>
          </tr> -->
          <tr *ngIf="selectedImage?.language">
            <td class="detail-label">Language:</td>
            <td>{{selectedImage?.language}}</td>
          </tr>
          <tr *ngIf="selectedImage?.button_text">
            <td class="detail-label">Button Text:</td>
            <td>{{selectedImage?.button_text}}</td>
          </tr>
          <tr *ngIf="selectedImage?.read_more_link">
            <td class="detail-label">Read More Link:</td>
            <td><a [href]="selectedImage?.read_more_link" target="_blank" class="detail-link">{{selectedImage?.read_more_link}}</a></td>
          </tr>
          <tr *ngIf="selectedImage?.start_date">
            <td class="detail-label">Start Date:</td>
            <td>{{selectedImage?.start_date | date : dateFormat}}</td>
          </tr>
          <tr *ngIf="selectedImage?.end_date">
            <td class="detail-label">End Date:</td>
            <td>{{selectedImage?.end_date | date : dateFormat}}</td>
          </tr>
          <tr *ngIf="selectedImage?.content_type">
            <td class="detail-label">Content Type:</td>
            <td>{{selectedImage?.content_type}}</td>
          </tr>
          <tr *ngIf="selectedImage?.image_size">
            <td class="detail-label">Image Size:</td>
            <td>{{selectedImage?.image_size}} kb</td>
          </tr>
          <tr *ngIf="selectedImage?.image_dimension">
            <td class="detail-label">Image Dimension:</td>
            <td>{{selectedImage?.image_dimension}}</td>
          </tr>
          <tr *ngIf="selectedImage?.created_by">
            <td class="detail-label">Created By:</td>
            <td>{{selectedImage?.created_by}}</td>
          </tr>
          <tr *ngIf="selectedImage?.created_time">
            <td class="detail-label">Created Time:</td>
            <td>{{selectedImage?.created_time | date : dateFormat}}</td>
          </tr>
          <tr *ngIf="selectedImage?.updated_by">
            <td class="detail-label">Updated By:</td>
            <td>{{selectedImage?.updated_by}}</td>
          </tr>
          <tr *ngIf="selectedImage?.updated_time">
            <td class="detail-label">Updated Time:</td>
            <td>{{selectedImage?.updated_time | date : dateFormat}}</td>
          </tr>
          <tr *ngIf="selectedImage?.status">
            <td class="detail-label">Status:</td>
            <td [ngClass]="getStatusClass(selectedImage?.status || 'default')">{{selectedImage?.status}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    
  </div>

  <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
    <button mat-button class="action-button" (click)="updateImage()">Update</button>
    <button mat-button class="action-button" (click)="deleteImage()">Delete</button>
  </div>
</div>
